export function anchorScroll() {
    const header = document.querySelector('header'); // of jouw header selector
    if (!header) return;

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
            const id = link.getAttribute('href');
            if (id === '#') return;

            const target = document.querySelector(id);
            if (!target) return;

            e.preventDefault();

            const offset = header.offsetHeight;
            const targetPos = target.getBoundingClientRect().top + window.pageYOffset;

            window.scrollTo({
                top: targetPos - offset,
                behavior: 'smooth'
            });
        });
    });
}
